import TemplateView from "../../TemplateView"
import messageResource from "../../messageResource"
import ProjectPanelDetails from "./ProjectPanelDetails"
import CommentsSection from './CommentsSection'
import {Description} from '../Description'

export default class ProjectPanelContent extends TemplateView {
    constructor({
        updateDescription = () => {},
        refreshScrollCb = () => {},
        scrollToElementCb = () => {},
    }) {
        super()

        this.state = {
            readOnly: false,
            description: "",
            active: false,
            projectSpentTimeValues: null,
            workflowStatuses: [],
            canReopenProject: false,
        };

        this.callbacks = {
            updateDescription,
            scrollToElementCb,
            refreshScrollCb,
        }

        this.onStateChanged(() => this.updateView());
    }

    templateHtml() {
        return "<div class='tab detailsTab'>" +
               "  <div class='details section'/>" +
               "  <div class='description section'>" +
               "    <div class='title'><%=description%></div>" +
               "    <div class='descriptionArea'></div>" +
               "  </div>" +
               "  <div class='commentsSectionPlaceholder'></div>" +
               "</div>";
    }

    shouldUpdateOnInit() {
        return false;
    }

    messageKeys() {
        return {
            description: "panel.common.description"
        }
    }

    afterRender() {
        this.$details = this.$containerEl.find(".details");
        this.details = new ProjectPanelDetails(this.$details).init();

        this.$description = this.$containerEl.find(".descriptionArea");
        this.description = new Description({
            onChange: this.callbacks.updateDescription,
        }).init(this.$description);
        this.description.setState({
            placeholder: messageResource.getMessage('project.edit_panel.description.empty')
        })
        new CommentsSection({
            refreshScrollCb: this.callbacks.refreshScrollCb,
            scrollToElementCb: this.callbacks.scrollToElementCb
        }).init(this.find('.commentsSectionPlaceholder'))
    }

    updateView() {
        this.details.setState({
            active: this.state.active,
            readOnly: this.state.readOnly,
            projectSpentTimeValues: this.state.projectSpentTimeValues,
            workflowStatuses: this.state.workflowStatuses,
            canReopenProject: this.state.canReopenProject,
        });
        this.details.show();

        this.description.setState({
            text: this.state.description,
            editable: !this.state.readOnly,
            placeholder: this.state.readOnly ? messageResource.getMessage('panel.common.description.no_description')
                : messageResource.getMessage('project.edit_panel.description.empty')
        });
    }

    updateLastAudit(lastUpdateAudit) {
        this.details.setLastAudit(lastUpdateAudit)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/project/ProjectPanelContent.js